import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/dearest/book/external-confirm/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/dearest/book/external-confirm",
)({
  component: Page,
});
